<script lang="ts">
import {defineComponent} from 'vue'
import PicSelector from "@/view/components/UploadCenter/picSelector.vue";
import BannerSelector from "@/view/components/UploadCenter/bannerSelector.vue";

export default defineComponent({
  name: "AddAccount",
  components: {BannerSelector, PicSelector},
  data () {
    return{
      tabs: 1,
    }
  },
  props: {
   value: Object
  },
})
</script>

<template>
  <div>
    <div class="row">
      <div class="col-6">
        <v-text-field
            append-icon="mdi-pen"
            class="mt-0 pt-0 contentinfo"
            clear-icon="mdi-close-circle-outline"
            clearable
            dense
            v-model="value.nameCollection"
            label="نام مجموعه"
            outlined
        />
      </div>
      <div class="col-6">
        <v-text-field
            append-icon="mdi-pen"
            class="mt-0 pt-0 contentinfo"
            clear-icon="mdi-close-circle-outline"
            clearable
            dense
            v-model="value.subTitle"
            label="زیر عنوان"
            outlined
        />
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <custom-tabs v-model="tabs" grow>
          <template v-slot:staticTabs>
            <v-tab :ripple="false">
              <div class="cornel-left"></div>
              <div class="cornel-right"></div>
              <div
                  class="d-flex row"
                  style="
                    justify-content: center !important;
                    align-items: center;
                  "
              >
                <v-icon class="me-2">mdi-plus</v-icon>
               لوگو
                <help-info
                    :element-name="`${serviceName}-${componentName}-added`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('feedbacks')"
                />
              </div>
            </v-tab>

            <v-tab :ripple="false">
              <div class="cornel-left"></div>
              <div class="cornel-right"></div>
              <div
                  class="d-flex row"
                  style="
                    justify-content: center !important;
                    align-items: center;
                  "
              >
                <v-icon class="me-2">mdi-plus</v-icon>
                تصویر
                <help-info
                    :element-name="`${serviceName}-${componentName}-added`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('add')"
                />
              </div>
            </v-tab>

          </template>

          <template v-slot:middle>
            <div class="py-2"></div>
          </template>

          <template v-slot:staticItems>
            <v-tab-item >
              <pic-selector :edit-name="false" key="selectLogo" :field.sync="value.logoImage"  single one-pic ></pic-selector>
            </v-tab-item>
            <v-tab-item>
              <pic-selector :edit-name="false" key="selectBack" :field.sync="value.background" single one-pic ></pic-selector>
            </v-tab-item>
          </template>
        </custom-tabs>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>